import React, { FunctionComponent } from 'react';

import {
  Input,
  Checkbox,
  Group,
  Field,
  FieldError,
  ToggleableField,
} from '../../components';
import { PasswordStrength } from '../../components/PasswordStrength/PasswordStrength';
import { AccountFieldsProps } from './AccountFields.types';

export const AccountFields: FunctionComponent<AccountFieldsProps> = props => {
  const { values } = props;

  return (
    <>
      <Group direction="column">
        <ToggleableField
          name="email"
          label="Email"
          toggleable={props.mode === 'review'}
          defaultMode={props.mode === 'review' ? 'display' : 'edit'}
        >
          {props => <Input {...props.input} type="email" disabled />}
        </ToggleableField>
        <FieldError name="email" />
      </Group>
      {props.mode === 'edit' && (
        <>
          <Group direction="column">
            <Field
              name="password"
              label="Password"
              type={values.showPassword ? 'text' : 'password'}
            >
              {props => <Input {...props.input} />}
            </Field>
            <Field name="password">
              {fieldProps =>
                (fieldProps.meta.touched || fieldProps.meta.active) && (
                  <PasswordStrength value={fieldProps.input.value} />
                )
              }
            </Field>
          </Group>

          <Field name="showPassword" type="checkbox">
            {props => (
              <Checkbox
                {...props.input}
                id="showPassword"
                label="Show Password"
                style={{ margin: '0.25rem' }}
              />
            )}
          </Field>
        </>
      )}
      {props.children}
    </>
  );
};
